import React from 'react'
import { Pane, Text } from 'evergreen-ui'
import { useStatusContent } from '../../../config/roundContent'

const StatusRegister_6 = ({ DataRegister }) => {
  const row = DataRegister?.[0] || {}
  const { statusContent } = useStatusContent(row.ROB_ID, "6")
  const body = statusContent.bodyText || statusContent.titleText

  return (
    <>
      <Pane
        color="#1b4332"
        fontWeight={700}
        backgroundColor="#d8f3dc"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        justifyContent="flex-start"
      >
        <Text color="#1b4332" fontWeight={700}>
          {statusContent.titleText || 'ยืนยันสิทธิ์'} {row.QUOTA_NAME}{" "}
          {row.ROB_NAME !== null ? row.ROB_NAME : ""}
        </Text>
        <Text color="#1b4332" fontWeight={700}>
          {row.Major1_faculty_name}{" "}
          {" หลักสูตร " + row.Major1_LEVEL_OPEN_NAME}
        </Text>
        <br />
        <Text color="#1b4332" fontWeight={700}>
          {row.Major1_MAJOR_ID + " : " + row.Major1_MAJOR_NAME}
        </Text>
      </Pane>
      {body ? (
        <Pane
          color="#aa3000ff"
          fontWeight={700}
          backgroundColor="#d40000ff"
          height="100%"
          paddingY={4}
          paddingX={5}
          fontSize={16}
          justifyContent="flex-start"
        >
          <Text color="#ffffffff" fontWeight={700}>
            {body}
          </Text>
        </Pane>
      ) : null}
    </>
  )
}

export default StatusRegister_6
